import React from "react";

import Backdrop from "./Backdrop";

import styled from "styled-components";

const Spinner = styled.div`
  width: 60%;
  padding: 10%;
  position: fixed;
  z-index: 7000;
  box-sizing: border-box;
  padding: 10px;
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center;
  top: 10%;
  left: calc(20%);
  background: white;
  border-radius: 5px;
  &::-webkit-scrollbar {
    display: none;
  }
  @media (max-width: 768px) {
    width: 100%;
    height: 100vh;
    top: 0%;
    left: calc(0%);
    border-radius: 0px;
    overflow-y: scroll;
    &::-webkit-scrollbar {
      display: none;
    }
  }
`;
const commonModal = (props) => (
  <div>
    <Backdrop clicked={props.closeModal} show={props.show} />
    <Spinner
      style={{
        transform: props.show ? "translateY(0)" : "translateY(-100vh)",
        opacity: props.show ? "1" : "0",
      }}
    >
      {props.children}
    </Spinner>
  </div>
);

export default commonModal;
